import React, { Component } from 'react';

class EmailStep extends Component {
  render() {
    const {
      data,
      email,
      emailIDError,
      emailIDErrorRecheck,
      isData,
      btnClicked,
      onEmailChange,
      onSubmit,
      onClosePopup
    } = this.props;

    const styles = data?.styles;

    return (
      <div>
        {/* {data?.isMobile && (
          <div className={styles.header_wrapper}>
            <div onClick={onClosePopup} className={styles.header_back_arrow}>
              <img src="/images/back-left-arrow.svg" alt="back-arrow" />
            </div>
            <h4 className={styles.header_title}>Manage Booking</h4>
          </div>
        )} */}
        <div className={styles.manage_booking_wrapper}>
          {/* Hero Section */}
          <div className={styles.manage_booking__hero}>
            <div className={styles.manage_booking__icon}>
              <img src="/images/manage-booking.svg" alt="manage-booking" />
            </div>
            <div className={styles.manage_booking_content}>
              <h4 className={styles.manage_book_heading}>Manage Booking</h4>
              <p className={styles.manage_book_label}>
                Retrieve your booking using your email address
              </p>
            </div>
          </div>
          <div className={styles.manage_booking_container}>
            <div className={styles.form_flex}>
              <div className={styles.Filt_inp_Wrap}>

                {/* <div className={styles.Filt_inp_bx}>
                  <div className={styles.label_input}>
                    <label className={styles.filt_label}>Booking Id</label>
                    <input
                      type="text"
                      className={styles.filt_inp}
                      placeholder="Enter Booking Id"
                      value={email}
                      onChange={onEmailChange}
                    />
                    <div className={styles.error_message}>
                      <span>
                        {emailIDError && !email ? "Please enter email address" : ""}
                      </span>
                      <span>
                        {emailIDErrorRecheck && email ? "Please enter valid email address" : ""}
                        {isData ? "Please Enter Valid Data" : ""}
                      </span>
                    </div>
                  </div>
                </div> */}

                <div className={styles.Filt_inp_bx}>
                  <div className={styles.label_input}>
                    <label className={styles.filt_label}>Email</label>
                    <input
                      type="text"
                      className={styles.filt_inp}
                      placeholder="Enter email Id"
                      value={email}
                      onChange={onEmailChange}
                    />
                    <div className={styles.error_message}>
                      <span>
                        {emailIDError && !email ? "Please enter email address" : ""}
                      </span>
                      <span>
                        {emailIDErrorRecheck && email ? "Please enter valid email address" : ""}
                        {isData ? "Please Enter Valid Data" : ""}
                      </span>
                    </div>
                    
                  </div>
                </div>
                {(emailIDErrorRecheck || isData) && (
                      <div className={styles.question_suggest}>
                        <h4 className={styles.question_suggest_details}>
                          If you have any questions or suggestions,<br /> you can call us at{" "}
                          <a href={`tel:${data?.siteData?.site?.support_number}`}>
                            {data?.siteData?.site?.support_number}
                          </a>{" "}
                          or email us at{" "}
                          <a href={`mailto:${data?.siteData?.site?.support_email}`}>
                            {data?.siteData?.site?.support_email}
                          </a>
                        </h4>
                      </div>
                    )}
                <div className={`${styles.filt_btn_bx} ${emailIDErrorRecheck ? styles.space_remove : ""}`}>
                  <button
                    onClick={() => onSubmit("send_otp")}
                    className={btnClicked ? `${styles.Filt_apply} loading` : styles.Filt_apply}
                    disabled={btnClicked}
                  >
                    {btnClicked ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </div>




            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default EmailStep;